import { useEffect } from 'react';
import { useFeatures } from '../context/FeaturesContext';
import { configurarColeta } from './coleta';

/**
 * Liga ou desliga a coleta conforme `intelligence_tracking` e `intelligence_tracking_percent`
 * do backend. Não desenha nada. Enquanto as flags não chegam, a coleta fica desligada.
 */
export default function ColetaInteligencia() {
    const { features, carregado } = useFeatures();
    const ligada = carregado && features.intelligence_tracking === true;
    const percentual = Number(features.intelligence_tracking_percent) || 0;
    useEffect(() => {
        configurarColeta({ ativo: ligada, percentual: ligada ? percentual : 0 });
    }, [ligada, percentual]);
    return null;
}
